import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./heartland_gateway.js";
//#region src/heartland_gateway_helper.ts
var heartland_gateway_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(gateway) {
	switch (gateway) {
		case "portico": return "Portico";
		case "transit": return "TransIT";
	}
}
//#endregion
export { heartland_gateway_helper_exports, name };

//# sourceMappingURL=heartland_gateway_helper.js.map